import { type Metric, onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';

import { getReporter } from './reporter';

/**
 * Subscribes to the core Web Vitals and forwards them through the shared
 * reporter. Call once during app bootstrap.
 *
 * The official recommendation is to register these ASAP after first paint
 * (the metrics themselves buffer events internally until subscribed).
 */
export function installWebVitals(): void {
  const send = (metric: Metric) => {
    getReporter().captureMetric(metric.name, metric.value, {
      rating: metric.rating,
      id: metric.id,
      navigationType: metric.navigationType,
    });
  };

  onCLS(send);
  onFCP(send);
  onINP(send);
  onLCP(send);
  onTTFB(send);
}
